export default __webpack_public_path__ + "images/8314a0acf45560609df49e6bdcc7178a-eastern_religion_small.webp";